import { getApiReducer } from "redux-store/api-sagas";

import { LOAD_DEPLOYMENTS_SUCCESS, LOAD_DEPLOYMENTS_FAILURE } from "./actions";

const deploymentsLoadReducer = getApiReducer(
  LOAD_DEPLOYMENTS_SUCCESS,
  LOAD_DEPLOYMENTS_FAILURE,
);

export { deploymentsLoadReducer as deploymentsReducer };
